module.exports = __webpack_public_path__ + "static/img/bg4.ab2ccb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg4.png
// module id = g41M
// module chunks = 0